import api from '@/api';

const store = {
  state: {
    hasNewWaiting: false,
    waitingId: null,
    waitingStores: [],
    dataWaiting: {
      waiting: [],
      seats: [],
      canceled: []
    },
    fetchingWaitingStores: false,
    fetchingWaiting: false,
    updatingWaiting: false
  },

  mutations: {
    SET_WAITING_STORES: (state, payload) => {
      state.waitingStores = payload;
    },
    SET_HAS_WAITING: (state, payload) => {
      state.hasNewWaiting = payload;
    },
    SET_WAITING_ID: (state, payload) => {
      state.waitingId = payload;
    },
    SET_IS_FETCHING_WAITING_STORES: (state, payload) => {
      state.fetchingWaitingStores = payload;
    },
    SET_WAITING_LIST: (state, payload) => {
      state.dataWaiting = payload;
    },
    SET_IS_FETCHING_WAITING: (state, payload) => {
      state.fetchingWaiting = payload;
    },
    SET_IS_UPDATING_WAITING: (state, payload) => {
      state.updatingWaiting = payload;
    }
  },

  getters: {
    GetHasNewWaiting: state => state.hasNewWaiting,
    GetWaitingId: state => state.waitingId,
    GetWaitingStores: state => state.waitingStores,
    GetWaitingList: state => state.dataWaiting,
    GetWaitingStoresFetching: state => state.fetchingWaitingStores,
    GetWaitingFetching: state => state.fetchingWaiting,
    GetWaitingUpdating: state => state.updatingWaiting
  },

  actions: {
    async GetWaitingStores({ commit, state }, payload) {
      try {
        commit('SET_IS_FETCHING_WAITING_STORES', true);
        const result = await api.GetOutletCodes(payload);
        commit('SET_IS_FETCHING_WAITING_STORES', false);
        commit('SET_WAITING_STORES', result.data.data);
        return result.data;
      } catch (e) {
        commit('SET_IS_FETCHING_WAITING_STORES', false);
        throw e;
      }
    },

    async GetWaitingListRequest({ commit, state }, payload) {
      try {
        commit('SET_IS_FETCHING_WAITING', true);
        const result = await api.GetWaitingData(payload);
        commit('SET_IS_FETCHING_WAITING', false);
        if (result.data.code === '200') {
          commit('SET_WAITING_LIST', result.data.data);
          commit('SET_WAITING_ID', result.data.data.id || 0);
        }
      } catch (e) {
        commit('SET_IS_FETCHING_WAITING', false);
        throw e;
      }
    },

    async UpdateWaitingRequest({ commit, state }, payload) {
      try {
        commit('SET_IS_UPDATING_WAITING', true);
        const result = await api.UpdateWaiting(payload);
        commit('SET_IS_UPDATING_WAITING', false);
        return result.data;
      } catch (e) {
        commit('SET_IS_UPDATING_WAITING', false);
        throw e;
      }
    },

    async GetNewWaitingRequest({ commit, state }, payload) {
      try {
        const result = await api.GetNewWaiting(payload);
        if (result.data.code === '200' && result.data.data.id && state.waitingId !== result.data.data.id) {
          commit('SET_WAITING_ID', result.data.data.id);
          commit('SET_HAS_WAITING', true);
        }
      } catch (e) {
        throw e;
      }
    }
  }
};

export default store;
